import {Tab} from 'bootstrap'
import {fileTypeFromBlob} from 'file-type'
import mime from 'mime'
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {addMethod, mixed} from 'yup'

import {
  DrawerComponent,
  MenuComponent,
  ScrollComponent,
  ScrollTopComponent,
  StickyComponent,
  SwapperComponent,
  ToggleComponent,
} from '../assets/ts/components'
import {ThemeModeComponent} from '../assets/ts/layout'
import {useLayout} from './core'

export function MasterInit() {
  const intl = useIntl()
  const {config} = useLayout()
  const [initialized, setInitialized] = useState(false)
  const pluginsInitialization = () => {
    ThemeModeComponent.init()
    setTimeout(() => {
      ToggleComponent.bootstrap()
      ScrollTopComponent.bootstrap()
      DrawerComponent.bootstrap()
      StickyComponent.bootstrap()
      MenuComponent.bootstrap()
      ScrollComponent.bootstrap()
      SwapperComponent.bootstrap()
      document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
        Tab.getOrCreateInstance(tab)
      })
    }, 500)
  }

  addMethod(mixed, 'file', function (options: FileSchema) {
    return this.test(
      'is-file',
      options?.message || intl.$t({id: 'GENERAL.FILE_REQUIRED'}),
      (value) => {
        if (!value) return true
        if (typeof options?.skip === 'function' && options?.skip(value)) return true
        return value instanceof File
      }
    )
  })

  addMethod(
    mixed,
    'fileSize',
    function ({maxSize = 256 * 1024 * 1024, message, skip}: FileSizeSchema = {}) {
      return this.file({skip}).test(
        'file-size',
        message || intl.$t({id: 'GENERAL.FILE_SIZE'}, {maxSize: maxSize / (1024 * 1024)}),
        (value) => {
          if (!value) return true
          if (typeof skip === 'function' && skip(value)) return true
          const file = value as File
          return file.size <= maxSize
        }
      )
    }
  )

  addMethod(
    mixed,
    'fileType',
    function ({
      extensions = [
        'pdf',
        'doc',
        'docx',
        'odt',
        'rtf',
        'txt',
        'xls',
        'xlsx',
        'ods',
        'csv',
        'ppt',
        'pptx',
        'odp',
        'jpg',
        'jpeg',
        'png',
      ],
      message,
      skip,
    }: FileTypeSchema = {}) {
      return this.file({skip}).test(
        'file-type',
        message || intl.$t({id: 'GENERAL.UNSUPPORTED_FILE'}),
        async (value) => {
          if (!value) return true
          if (typeof skip === 'function' && skip(value)) return true
          try {
            const file = value as File
            const ext = mime.getExtension(file.type)
            if (!ext) return false

            // non supported file types by file-type package
            if (['doc', 'xls', 'ppt', 'msi', 'csv', 'svg'].includes(ext)) {
              return extensions.includes(ext.toLowerCase())
            }

            const typeInfo = await fileTypeFromBlob(file) // Detect from binary
            if (!typeInfo) return false // Could not detect type
            return extensions.includes(typeInfo.ext.toLowerCase())
          } catch {
            return false
          }
        }
      )
    }
  )

  useEffect(() => {
    if (!initialized) {
      setInitialized(true)
      pluginsInitialization()
    }
  }, [config, initialized])

  return <></>
}
